// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;O Lord, you know all my desires&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and my sighing is not hidden from you.<br> </p> </div></div>";
// Exports
module.exports = code;